import { Component, Input, Output, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ShelvableBackend, LoginOptions } from '../../services/ShelvableBackend/ShelvableBackend'
import { ImageResizer } from '../../services/ImageResizer'
import { Utilities } from '../../services/Utilities'
import { NgbModal, NgbActiveModal } from '@mattlewis92/ng-bootstrap';
import { Subscription, Observable, BehaviorSubject } from 'rxjs';
import { StateService } from '@uirouter/angular';

import { Analytics } from '../../services/Analytics'

import { ImageCropComponent } from '../image-crop/image-crop'

import swal from 'sweetalert';

@Component({
    selector: 'user-management',
    templateUrl: './user-management.html',
    styleUrls: ['./user-management.css'],
    encapsulation: ViewEncapsulation.None
})
export class UserManagementComponent implements OnDestroy {
    authState:any;
    emailDetails:Observable<any>;
    canResendConfirmation:boolean = true;
    timeRemaining:string = '';
    countdownInterval:number;
    isGettingStarted:boolean = false;

    displayName:string;
    subtitle:string;
    
    importStatus = {
        active: false,
        ready: false,
        complete: false,
        errors: false,
        doImport:() => console.warn("doImport() called before ready.")
    };

    ProposedEmailAddress = class {
        constructor(private isEmailValid:(emailAddress:string) => boolean, private emailDetails:Observable<any>) {}

        isEditing:boolean = false;

        value = new BehaviorSubject<string>(null);

        async reset() {
            var data = await this.emailDetails.take(1).toPromise();
            this.value.next(data.address);
        }

        isValid = this.value.map(this.isEmailValid).shareReplay(1)
    };
    
    proposedEmailAddress = new this.ProposedEmailAddress((e) => this.isEmailValid(e), this.shelvableBackend.emailDetails);

    resendConfirmationEmail:() => void;
    resubscribe:() => void;

    fromExplore:boolean;

    selecting:boolean = false;
    tabSelect() {
        this.selecting = !this.selecting;
    }

    login(provider:string, options:LoginOptions) {
        this.shelvableBackend.loginWithProvider(provider, options).catch(() => {
            swal("There was an issue logging you in.", "Sorry about that.", "error");
        });
    }

    communicationTabActive:boolean = (window.location.hash === "#communication"); 
    userData:Observable<any>;
    updateUserData = (data) => this.shelvableBackend.updateUserData(data);

    logOut() {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;

        this.shelvableBackend.logOut();
    };

    async claimUsername() {     
        var proposedUsername = await this.proposedUsername.take(1).toPromise();
        if (proposedUsername === '' || proposedUsername === null) {
            return;
        }

        var isAvailable = await this.shelvableBackend.checkUserExists(proposedUsername).filter(Utilities.isNotNull);
        if (!isAvailable) {
            return;
        }

        try {
            await this.shelvableBackend.claimUsername(proposedUsername);
            
            Analytics.register();
            this.shelvableBackend.gettingStartedStages.begin();
            this.isGettingStarted = true;
        } catch (err) {
            swal("There was an issue setting that username. Maybe try another.", err, "error")
        }   
    };

    emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    async setEmailIfValid() {
        var proposedEmail = await this.proposedEmailAddress.value.take(1).toPromise();
        if (this.isEmailValid(proposedEmail)) {
            var serverAddress = await this.emailDetails.take(1).pluck('address').toPromise();
            if (proposedEmail === serverAddress) {
                this.proposedEmailAddress.isEditing = false;
            } else {
                swal({
                    title: 'Are you sure you want to change your email to ' + proposedEmail + '?',
                    type: "info",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Yes, change it.",
                    cancelButtonText: "No, leave it.",
                    closeOnConfirm: true,
                    closeOnCancel: true
                }, async (isConfirmed) => {
                    if (isConfirmed) {
                        await this.shelvableBackend.setEmailAddress(proposedEmail);
                        this.proposedEmailAddress.isEditing = false;
                    }
                });
            }
        }
    };
    
    private isEmailValid(emailAddress:string) {
        console.log('checking validity of ' + emailAddress)
        return this.emailRegex.test(emailAddress); 
    }

    async showImageCropModal() {
        try {
            var result = await this.modalService.open(ImageCropComponent, {/* animation: true */}).result;
            if (result) {
                try {
                    var resizedImage = await this.imageResizer.resize(result);
                    this.shelvableBackend.setProfilePicture(resizedImage);
                } catch (err) {
                    console.error(err);
                    swal("There was an error setting your profile picture.", "Please try again.", "error");
                };
            }
        } catch (err) {
            console.log('Image crop modal closed.')
        }
        Utilities.reAddModalOpen();
    };

    
    proposedUsername = new BehaviorSubject<string>('');    

    usernameCheck = this.proposedUsername.filter(ShelvableBackend.isUsernameValid).flatMap((username) =>
        Observable.combineLatest([
            this.shelvableBackend.checkUserExists(username), 
            this.shelvableBackend.isUsernameReserved(username)
        ], (usernameExists, usernameReserved) => {
            if (usernameExists == null || usernameReserved == null) {
                return null;
            } else {
                return !usernameExists && !usernameReserved;
            }
        })
    ).shareReplay(1);

    usernameValidationStatus = {
        isAvailable: this.usernameCheck.filter(Utilities.isNotNull),
        currentlyChecking: this.usernameCheck.map((c) => c === null),
        isValid: this.proposedUsername.map(ShelvableBackend.isUsernameValid)
    };
    
    isLoggedIn:Observable<boolean>;
    isRegistered:Observable<boolean>;
    profilePicUrl:Observable<string>;
    username:Observable<string>;
    provider:Observable<string>;

    private emailSubscription:Subscription;
    constructor(public shelvableBackend:ShelvableBackend, private modalService: NgbModal, protected activeModal: NgbActiveModal, private imageResizer:ImageResizer, private stateService:StateService) {
        this.authState = shelvableBackend.authState;
        
        this.fromExplore = stateService.$current.parent && (stateService.$current.parent.name === 'exploreAuthor' || stateService.$current.parent.name === 'exploreSubject');
        if (this.fromExplore) {
            // TODO: put $scope.topicName in here
            debugger;
        }
        
        this.userData = shelvableBackend.loggedInUserData;
        this.emailDetails = shelvableBackend.emailDetails;
        this.resendConfirmationEmail = () => shelvableBackend.sendConfirmEmail();
        this.resubscribe = shelvableBackend.resubscribe;

        this.isLoggedIn = shelvableBackend.loggedInUserObs.isLoggedIn;
        this.isRegistered = shelvableBackend.loggedInUserObs.isRegisteredObs;
        this.profilePicUrl = shelvableBackend.loggedInUserObs.profilePicUrlObs;
        this.username = shelvableBackend.loggedInUserObs.usernameObs;
        this.provider = shelvableBackend.loggedInUserObs.providerObs;
        
        var emailSubscription = this.emailDetails.subscribe((emailDetails) => {
            this.proposedEmailAddress.value.next(emailDetails.address);
            
            if (!emailDetails.isConfirmed && (emailDetails.lastConfirmEmailSent + 300000) > Date.now()) {
                if (this.countdownInterval) {
                    return;
                }
                this.countdownInterval = setInterval(() => {
                    var timeRemaining = Math.floor((300000 - (Date.now() - emailDetails.lastConfirmEmailSent)) / 1000);
                    if (timeRemaining <= 0) {
                        this.canResendConfirmation = true;
                        this.timeRemaining = '';
                        clearInterval(this.countdownInterval);
                        this.countdownInterval = null;
                    } else {
                        this.canResendConfirmation = false;
                        this.timeRemaining = (timeRemaining >= 60 ? `${Math.floor(timeRemaining / 60)} minute${Math.floor(timeRemaining / 60) === 1 ? '' : 's'}, ` : '') + `${timeRemaining % 60} second${timeRemaining % 60 === 1 ? '' : 's'}`;
                    }
                }, 1000);
            } else {
                this.canResendConfirmation = true;
                this.timeRemaining = '';
            }
        })

    }

    ngOnDestroy() {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;

        if (this.emailSubscription) {
            this.emailSubscription.unsubscribe();
        }
    }
}




// WEBPACK FOOTER //
// ./web/static/components/user-management/user-management.ts